import React from 'react';

const OffMarketSection = () => {
  return (
    <div className="bg-zinc-900/80 text-white py-10 text-center mt-20 lg:mt-28">
      <h2 className="text-xl md:text-2xl font-bold mb-4">
        Exklusive Fahrzeuge – Off Market
      </h2>
      <p className="text-sm md:text-base max-w-xl mx-auto mb-6">
        Du suchst etwas Außergewöhnliches? Viele unserer Top-Modelle findest du nicht online – wir vermitteln sie diskret und persönlich.
      </p>
      <a href="#contact" className="border border-white px-6 py-2 rounded-md font-semibold  transition">
        Kontakt
      </a>
    </div>
  );
};

export default OffMarketSection;
